// ─── Asset Slice ─────────────────────────────────────────────────────────────
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import assetService from '../../services/assetService';

export const fetchAssets = createAsyncThunk('asset/fetchAll', async (_, { getState }) => {
  return await assetService.getAll(getState().auth.token);
});
export const fetchTransfers = createAsyncThunk('asset/fetchTransfers', async (_, { getState }) => {
  return await assetService.getTransfers(getState().auth.token);
});
export const fetchDisposals = createAsyncThunk('asset/fetchDisposals', async (_, { getState }) => {
  return await assetService.getDisposals(getState().auth.token);
});
export const createAsset = createAsyncThunk('asset/create', async (assetData, { getState }) => {
  return await assetService.create(assetData, getState().auth.token);
});
export const updateAsset = createAsyncThunk('asset/update', async ({ id, data }, { getState }) => {
  return await assetService.update(id, data, getState().auth.token);
});
export const deleteAsset = createAsyncThunk('asset/delete', async (id, { getState }) => {
  await assetService.remove(id, getState().auth.token);
  return id;
});

const assetSlice = createSlice({
  name: 'asset',
  initialState: {
    assets: [], transfers: [], disposals: [],
    selectedAsset: null, loading: false, error: null,
  },
  reducers: {
    setSelectedAsset: (state, action) => { state.selectedAsset = action.payload; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssets.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchAssets.fulfilled, (state, action) => { state.loading = false; state.assets = action.payload; })
      .addCase(fetchAssets.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchTransfers.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchTransfers.fulfilled, (state, action) => { state.loading = false; state.transfers = action.payload; })
      .addCase(fetchTransfers.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(fetchDisposals.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchDisposals.fulfilled, (state, action) => { state.loading = false; state.disposals = action.payload; })
      .addCase(fetchDisposals.rejected, (state, action) => { state.loading = false; state.error = action.error.message; })
      .addCase(createAsset.fulfilled, (state, action) => { state.assets.unshift(action.payload); })
      .addCase(updateAsset.fulfilled, (state, action) => {
        const idx = state.assets.findIndex(a => a.id === action.payload.id);
        if (idx >= 0) state.assets[idx] = action.payload;
      })
      .addCase(deleteAsset.fulfilled, (state, action) => {
        state.assets = state.assets.filter(a => a.id !== action.payload);
      });
  },
});

export const { setSelectedAsset } = assetSlice.actions;
export default assetSlice.reducer;
